<p>widget-settings-debug-chart-config works!</p>
